import { List, makeStyles } from '@material-ui/core';
import { useCallback, VFC } from 'react';
import { useSelector } from 'react-redux';
import { CartListItem } from '../components/Products/CartListItem';
import { PrimaryButton } from '../components/Uikit/PrimaryButton';
import { PrimaryOutlineButton } from '../components/Uikit/PrimaryOutlineButton';
import { RootState } from '../reducks/store/store';
import { getProductsInCart } from '../reducks/users/selectors';
import { ProductInCart } from '../reducks/users/types';
import Container from '@mui/material/Container';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles({
  root: {
    margin: '0 auto',
    maxWidth: 512,
    width: '100%',
  },
  row: {
    display: 'flex',
    flexFlow: 'row wrap',
    marginBottom: 16,
  },
  label: {
    marginLeft: 0,
    marginRight: 'auto',
    fontSize: '25px',
  },
  value: {
    fontWeight: 600,
    marginRight: 0,
    marginLeft: 'auto',
    fontSize: '25px',
  },
});

const CartList: VFC = () => {
  const classes = useStyles();

  const selector = useSelector((state: RootState) => state);
  const navigate = useNavigate();

  // カート内商品
  const productsInCart = getProductsInCart(selector);
  const subtotal = productsInCart.reduce(
    (sum: number, product: ProductInCart) => (sum += product.price * product.quantity),
    0
  );

  /**
   * 注文に進む.
   */
  const goToOrder = useCallback(() => {
    navigate('/order/confirm');
  }, [navigate]);

   /**
    * トップに戻る.
    */
  const backToHome = useCallback(() => {
    navigate('/');
  }, [navigate]);

  return (
    <section className='mx-auto my-0 max-w-xl relative py-0 px-4 text-center w-full sm:max-w-5xl'>
      <h2 className='text-pandacco text-2xl mt-0 mx-auto mb-4'>
        注文内容
      </h2>
      <List className={classes.root}>
        {productsInCart.length > 0 ? (
          !productsInCart.every((product: ProductInCart) => product.quantity === 0) ? (
            productsInCart.map((product: ProductInCart) => (
              product.quantity !== 0 ? <CartListItem product={product} key={product.id} /> : null
            ))
          ) : (
            <p className='text-gray-500 text-xl'>カート内に商品が入っていません</p>
          )
        ) : (
          <p className='text-gray-500 text-xl'>カート内に商品が入っていません</p>
        )}
      </List>
      <div className='h-8 sm:h-12' />
      <Container
        sx = {{
          width: {xs: '80%', sm: '50%'}
        }}
      >
      <div className={classes.row}>
        <div className={classes.label}>{'合計(税込)'}</div>
        <div className={classes.value}>{`¥${subtotal}`}</div>
      </div>
      </Container>
      <div className='items-center flex flex-col'>
      {productsInCart.length > 0 && (
        !productsInCart.every((product: ProductInCart) => product.quantity === 0) && (
          <PrimaryButton label={'注文手続きへ'} onClick={goToOrder} />
        )
      )}
        <div className='h-3 sm:h-4' />
        <PrimaryOutlineButton label={'注文を続ける'} onClick={backToHome} />
      </div>
    </section>
  );
};

export default CartList;
